import Flexbox from './flexbox'
import FlexboxItem from './flexbox-item'

export {
  Flexbox,
  FlexboxItem
}



// WEBPACK FOOTER //
// ./node_modules/vux/src/components/flexbox/index.js